const CounterActionType = {
	INCREMENT: "INCREMENT",
	ASYNC_INCREMENT: "ASYNC_INCREMENT",
	DECREMENT: "DECREMENT",
	ASYNC_DECREMENT: "ASYNC_DECREMENT",
};

export default CounterActionType;
